// Data source for the TopHat component.
// Follow the same object structure to add another "mode" to the component.
// In TopHat.Vue add the new key on L20 for the validator and custom style if needed.

const topHatData = {
    'content-connects': {
        icon: { name: 'caret-right' },
        link: { url: 'https://thisiscareerconnect.discoveryeducation.com/org-902ba65b-268b-4063-860b-61b9a5ecbd7c' },
        text: 'Explore Collecting and Analyzing Data Resources',
    },
    'fin-lit-month': {
        icon: { name: 'caret-right' },
        link: { url: 'https://thisiscareerconnect.discoveryeducation.com/fin-lit-content-connection' },
        text: 'Explore Financial Literacy Month Resources',
    },
};
export default topHatData;
